export const DEFAULT_PBL_VALUE = '1234567812345678';
export const FILE_NAME = 'export device list';
export const ROWS_PER_PAGE = [5, 10, 25, 50, 100];
export const ROWS_PER_PAGE_2 = [25, 50, 100, 200, 500];
export const ROWS_PER_PAGE_3 = [5, 10, 15, 20, 25];
export const TIME_OUT_200 = 200;
export const MAX_SELECTED_ITEMS = 500;
export const DEVICE_STATUS_TYPE_ALL = 'all';
export const DRAWER_WIDTH_OPEN = 280;
export const DRAWER_WIDTH_CLOSE = 64;
export const PAGE_SIZE = 10;
export const PAGE_SIZE_2 = 5;
export const AUTO_HIDE_DURATION = 30000;
export const ANCHO_ORIGIN_SNACHBAR = { vertical: 'bottom', horizontal: 'left' };
export const DATE_FORMAT = 'MM/DD/YYYY'
